__turbopack_context__.v({
  "card": "xVcowG_card",
  "cardSubtitle": "xVcowG_cardSubtitle",
  "cardText": "xVcowG_cardText",
  "cardTitle": "xVcowG_cardTitle",
  "cards": "xVcowG_cards",
  "fadedOverlay": "xVcowG_fadedOverlay",
  "grid": "xVcowG_grid",
  "headingSubtitle": "xVcowG_headingSubtitle",
  "headingTitle": "xVcowG_headingTitle",
  "headingWrap": "xVcowG_headingWrap",
  "icon": "xVcowG_icon",
  "iconImage": "xVcowG_iconImage",
  "inner": "xVcowG_inner",
  "section": "xVcowG_section",
});
